import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { GenericService } from '../../commons/generic.service';

@Injectable()
export class UploadService extends GenericService {
    private relativePath = 'api/v1/inclusao-declaracao-ir';

    constructor(http: HttpClient) {
        super(http);
    }
    uploadComprovanteIR(ano: number, arquivo: File): Observable<any> {
        const formData = new FormData();
        formData.append('ano', ano.toString());
        formData.append('comprovanteIr', arquivo);

        return this.postMethodFile(this.relativePath + '/upload-comprovante', formData);
    }
}